import React from 'react';
import GenericAutoLoanModuleView from './GenericAutoLoanModuleView';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { AUTO_LOAN_VERTICAL } from 'types/marketplaceTiles.constants';

const GenericAutoLoanModuleController = props => {
  const loading = props.globalLoadingFlag || !props.genericAutoLoanOffers;

  const trackingAtr = getViewModuleTrackingAttributes({
    moduleName: props.moduleName,
    modulePosition: props.modulePosition,
    vertical: AUTO_LOAN_VERTICAL,
  });

  const seenPixel = useSeenModulePixel(trackingAtr);

  if (loading) {
    return null;
  } else {
    return (
      <>
        {seenPixel}
        <GenericAutoLoanModuleView {...props} />
      </>
    );
  }
};

export default GenericAutoLoanModuleController;
